"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiMainLayout = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const CoreuiMainLayoutComponent = ({ children, header, sidebar }) => (react_1.default.createElement("div", { className: "app sidebar-md-show sidebar-fixed header-fixed" },
    header,
    react_1.default.createElement("div", { className: "app-body" },
        sidebar,
        react_1.default.createElement("div", { className: "main" },
            react_1.default.createElement("div", { className: "animated fadeIn container-fluid", style: { paddingTop: '20px' } }, children)))));
CoreuiMainLayoutComponent.propTypes = {
    children: prop_types_1.default.node.isRequired,
    header: prop_types_1.default.node.isRequired,
    sidebar: prop_types_1.default.node.isRequired,
};
exports.CoreuiMainLayout = CoreuiMainLayoutComponent;
//# sourceMappingURL=CoreuiMainLayout.js.map